import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgxCurrencyInputMode } from 'ngx-currency';
import { Router } from '@angular/router';

import { EmployeeService } from './../../../pages/employee/services/employee.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { UtilityService } from '../../../core/services/utility.service';
import { HomeService } from './../../../pages/home/services/home.service';
import { ReadOnlyPdfViewerComponent } from 'src/app/shared/component/read-only-pdf-viewer/read-only-pdf-viewer.component';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css'],
  providers: [],
})
export class ConfirmationModalComponent implements OnInit {
  @Input() data: any;
  @Input() selectedEmployee: any;
  @Input() errorMsg: string;
  @ViewChild(ReadOnlyPdfViewerComponent) ReadOnlyPdfViewerComponent: ReadOnlyPdfViewerComponent;
  expenseData: { [key: string]: any } = {};
  options: { [key: string]: any } = {};
  currencySymbol: string;
  format: string;
  portalSettings: any;
  employeeInfo: any;
  formData: { [key: string]: any } = {};
  extenion: string;
  isOpen: any[];
  savedFiles: any[];
  newFiles: any[];
  expensePostingType: string;
  attachmentList: any[];
  bdatePickerOptions: {
    dateInputFormat: string;
    containerClass: string;
    showTodayButton: boolean;
    showClearButton: boolean;
    clearPosition: string;
    showWeekNumbers: boolean;
  };
  mobileMode: boolean;
  catList: any[] = [];
  showExpenseCategory = false;
  printMode = 'NewWindow';
  downloadURL: string | null = null;
  fileIsNotViewable = true;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    portalSettingsService: PortalSettingsService,
    employeeInfoService: EmployeeInfoService,
    private employeeService: EmployeeService,
    private utilityService: UtilityService,
    private homeService: HomeService,
    private router: Router
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
    this.format = utilityService.getDateFormat().toUpperCase();
    this.mobileMode = utilityService.isMobileMode();
  }

  ngOnInit(): void {
    this.bdatePickerOptions = {
      dateInputFormat: this.format.toUpperCase(),
      containerClass: 'theme-blue',
      showTodayButton: true,
      showClearButton: true,
      clearPosition: 'left',
      showWeekNumbers: false,
    };
    this.formData.selectedAttachment = {};
    this.getExpenseModel();
    this.getCatg();
    this.showExpenseCategory = this.portalSettings.ExShowExpenseCategory.ConfigValue == '1';
    this.expensePostingType = this.portalSettings.ExpensePostingType.ConfigValue;
    this.currencySymbol = this.utilityService.getCurrencySymbol(this.employeeInfo.PRCo);
    this.options = { align: 'left', prefix: this.currencySymbol, precision: 2, nullable: true, inputMode: NgxCurrencyInputMode.Natural };
  }

  getExpenseModel() {
    var userKeyID = this.selectedEmployee ? this.selectedEmployee.UserKeyID : null;
    var requestParam = 'receiptID=' + this.data.newID + '&returnMode=E';
    this.employeeService.getExpenseReceipts(requestParam).then((response: any) => {
      this.expenseData = response[0];
      this.expenseData.ExpenseDate = new Date();
      this.expenseData.ReceiptItemID = this.data.receiptItemID;
      this.getAttachment();
    });
  }

  getCatg() {
    this.openModal();
    this.employeeService.getCategory().then((response: any) => {
      if (response != null) {
        this.catList = [];
        response.forEach((val: any) => {
          if (val.IsActive) this.catList.push(val);
        });
      }
    });
    this.closeModal();
  }

  getAttachment() {
    this.savedFiles = [];
    this.newFiles = [];
    this.employeeService.getLineAttachments(this.expenseData.ReceiptID, null).then((response: any) => {
      this.savedFiles = response;
      if (this.savedFiles && this.savedFiles.length > 0) {
        this.formData.selectedAttachment = this.savedFiles[0];
      }
      this.attachmentList = [];
      response.forEach((val: { AttachmentFileName: string }) => {
        var tempExten = val.AttachmentFileName.slice(val.AttachmentFileName.lastIndexOf('.'), val.AttachmentFileName.length);
        if (
          tempExten.toLowerCase() == '.jpg' ||
          tempExten.toLowerCase() == '.jpeg' ||
          tempExten.toLowerCase() == '.png' ||
          tempExten.toLowerCase() == '.tif' ||
          tempExten.toLowerCase() == '.tiff'
        )
          this.attachmentList.push(val);
      });
    });
  }

  openEditExpenseReceipt() {
    this.openModal();
    this.employeeService
      .insertUpdateReceipt(
        this.expenseData.ReceiptID,
        this.selectedEmployee == null ? this.data.SubmittedByUserKeyID : this.selectedEmployee.UserKeyID,
        this.employeeInfo.PRCo,
        this.expenseData.ReceiptDescription,
        moment(this.expenseData.ExpenseDate, this.format.toUpperCase()).format('YYYY-MM-DD'),
        this.expenseData.ExpenseCatgID,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.expenseData.Amount
      )
      .then((response: any) => {
        this.employeeService
          .insertUpdateReceiptItem(this.data.receiptItemID, response.newID, this.expenseData.Amount || 0)
          .then((itemResponse: any) => {
            this.closeModal();
            this.activeModal.dismiss();
            this.router.navigate(['/employee/editexpensereceipt/'], {
              fragment:
                'receiptID/' +
                this.expenseData.ReceiptID +
                '/proxyuserID/' +
                (this.selectedEmployee == null ? null : this.selectedEmployee.UserKeyID),
            });
          })
          .catch((error: any) => {
            this.errorMsg = error?.error?.error ?? 'An error has occured.';
          });
      })
      .catch((error: any) => {
        this.errorMsg = error?.error?.error ?? 'An error has occured.';
      });
  }

  cancelClicked() {
    this.openModal();
    this.employeeService
      .insertUpdateReceipt(
        this.expenseData.ReceiptID,
        this.selectedEmployee == null ? this.data.SubmittedByUserKeyID : this.selectedEmployee.UserKeyID,
        this.employeeInfo.PRCo,
        this.expenseData.ReceiptDescription,
        moment(this.expenseData.ExpenseDate, this.format.toUpperCase()).format('YYYY-MM-DD'),
        this.expenseData.ExpenseCatgID,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.expenseData.Amount
      )
      .then((response: any) => {
        this.employeeService
          .insertUpdateReceiptItem(this.data.receiptItemID, response.newID, this.expenseData.Amount || 0)
          .then((itemResponse: any) => {
            this.activeModal.close('close');
            this.closeModal();
          })
          .catch((error: any) => {
            this.errorMsg = error?.error?.error ?? 'An error has occured.';
          });
      })
      .catch((error: any) => {
        this.errorMsg = error?.error?.error ?? 'An error has occured.';
      });
  }

  openModal() {
    document.getElementById('modalShare').style.display = 'block';
    document.getElementById('fadeShare').style.display = 'block';
  }

  closeModal() {
    document.getElementById('modalShare').style.display = 'none';
    document.getElementById('fadeShare').style.display = 'none';
  }
}
